@if (workflow; as wf) {
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>{{wf.currentTask?.definition?.workflowName}} -
      {{wf.currentTask?.definition?.name}}</mat-card-title>
      <mat-card-subtitle>
        <b>Status:</b> {{wf.currentTask?.state?.display}}
        @if (wf.currentTask?.dueDate) {
          <b>Due:</b> {{wf.currentTask?.dueDate | date : 'dd-MMM-yyyy'}}
        }
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content [ngClass]="{'full-content': type === 'full'}">
      @switch (type) {
        @case ('lite') {
          @if (wf.currentTask?.assignedTo) {
            Assigned: {{wf.currentTask?.assignedTo?.firstName}} {{wf.currentTask?.assignedTo?.lastName}} <br />
          }
          <a class="right-align mat-primary-link" (click)="onWorkflowDetailToggle($event)">more details...</a>
        }
        @case ('full') {
          <mat-accordion multi="false">
            @if (detail) {
              <mat-expansion-panel expanded="true">
                <mat-expansion-panel-header>
                  <mat-panel-title>Workflow Details</mat-panel-title>
                </mat-expansion-panel-header>
                <ip-detail [detail]="detail"></ip-detail>
              </mat-expansion-panel>
            }
            @if (files && files.length > 0) {
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title><span class="title-text">Workflow Documents</span></mat-panel-title>
                  <span class="badge">{{files.length}}</span>
                </mat-expansion-panel-header>
                <mat-list>
                  @for (doc of files; track doc) {
                    <mat-list-item>
                      <span matLine matListItemTitle matTooltip="{{ doc.primaryDisplay }}">
                        <span class="file-title">
                          <img
                            class="doc-icon"
                            [attr.src]="'assets/doc-icons/icon-' + getDocIcon(doc) + '.png'"
                            alt="icon"
                            (click)="onWorkflowFileEvent($event, 'icon', doc)"
                            />
                          <span (click)="onWorkflowFileEvent($event, 'text', doc)">
                            {{ doc.primaryDisplay }}
                          </span>
                        </span>
                      </span>
                      <span class="doc-details">{{ doc.secondaryDisplay }}</span>
                      <a class="icon-link" matListItemMeta matTooltip="Actions"
                        #trigger=matMenuTrigger [matMenuTriggerFor]="menu" [matMenuTriggerData]="{ doc }">
                        <mat-icon>more_vert</mat-icon>
                      </a>
                    </mat-list-item>
                  }
                </mat-list>
              </mat-expansion-panel>
            }
          </mat-accordion>
        }
      }
    </mat-card-content>
    @if (isFeatureEnabled('workflowActions')) {
      <mat-card-actions align="end">
        <button [disabled]="wf.currentTask?.assignedTo" mat-button color="primary"
        (click)="onWorkflowActionClickEvent($event, wf, 'ClaimCurrentTask')">Claim</button>
        <button [disabled]="!(wf.currentTask?.assignedTo && (isAdmin() || isWFAssignedToMe(wf.currentTask!)))"
        mat-button color="primary" (click)="onWorkflowActionClickEvent($event, wf, 'UnclaimCurrentTask')">Unclaim</button>
      </mat-card-actions>
    }
  </mat-card>
}